import type { JSX } from 'react';

import { SpriteIcon } from '../sprite-icon';
import type { SVGProps } from '../types';

const CircleErrorOutlineIcon = (props: SVGProps): JSX.Element => {
  return <SpriteIcon spriteId="x-circle" {...props} />;
};

export { CircleErrorOutlineIcon };
